export function AiGroundingChip({ groundedIn }) {
  if (!groundedIn || !groundedIn.routeLabel) return null;
  const { routeLabel, entityLabel, entityId } = groundedIn;
  const tail = entityLabel || entityId;
  return (
    <div
      className="ai-grounding-chip"
      title="The AI was told which page you're on. Citations show the underlying sources."
      role="note"
      aria-label={`Answering about ${routeLabel}${tail ? ' ' + tail : ''}`}
    >
      <span className="ai-grounding-pin" aria-hidden>
        ◎
      </span>
      <span className="ai-grounding-label">Answering about:</span>
      <span className="ai-grounding-route">{routeLabel}</span>
      {tail ? (
        <>
          <span className="ai-grounding-sep" aria-hidden>
            ·
          </span>
          <span className="ai-grounding-entity">{tail}</span>
        </>
      ) : null}
    </div>
  );
}
